import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Customer, CustomerCreate, CustomerFilter } from '../data/customer';

export function createCustomerService(client: AxiosInstance) {
  return createCrudService<Customer, CustomerCreate, CustomerFilter>(client,
    "/crm/Customer",
    "customerId",
  );
}

export type CustomerService = CrudService<Customer, CustomerCreate, CustomerFilter>;
